module.exports = __webpack_public_path__ + "static/media/29COICT3.1631a201.jpg";